import {
  api,
  // apiNotSensedia
} from '../middlewares';

function getAllNotifications() {
  return api.get('Notificacao/GetAll');
  // return apiNotSensedia.get("notificacao/getall");
}

function getNotifDestaques() {
  return api.get('Notificacao/GetNotificacoesDestaques');
}

function getNotifNoticias() {
  return api.get('Notificacao/GetNotificacoesNoticias');
}

function getNotifVideos() {
  return api.get('Notificacao/GetNotificacoesVideos');
}

function getNotifFase() {
  return api.get('Notificacao/GetNotificacoesSolicitacaoFase');
}

function getNotifFotos() {
  return api.get('Notificacao/GetNotificacoesAtualizacaoFotos');
}

function getUrlFotoS3(idAws) {
  return api.get('Home/GetUrlFotoS3', { params: { idAws } });
}

function getNotificationHistoric() {
  return api.get('Notificacao/GetBoletosPendentes');
}

function getBoletosVencidos() {
  return api.get('Notificacao/GetBoletosVencidos');
}

function getParcelasPendentes() {
  return api.get('Notificacao/GetParcelasPendentes');
}

function getParcelasVencidas() {
  return api.get('Notificacao/GetParcelasVencidas');
}

function getAgendamentosAbertos() {
  return api.get('Solicitacao/AgendamentosAbertos');
}

function getAniversarioNotificacao() {
  return api.get('Solicitacao/GetNotificacaoAniversario');
}

function getVistoriaNaoCompareceu() {
  return api.get('Solicitacao/GetNotificacaoVistoriaNaoCompareceu');
}

const getSurveyQuestions = async ({ Grupo, Subgrupo, assetId }) => {
  const NOTIFICATIONS_SURVEY_RESEARCH = JSON.parse(
    sessionStorage.getItem('notificationsPesquisa')
  );

  if (NOTIFICATIONS_SURVEY_RESEARCH?.length > 0) {
    try {
      const { data } = await api.get(
        `PesquisaSatisfacao/GetAllPerguntasBySubgrupo`,
        {
          params: {
            Grupo,
            Subgrupo,
            assetId,
          },
        }
      );

      if (data) return data;
    } catch (error) {
      return false;
    }
  }
};

const postSurveyQuestions = async (
  question,
  imovelId,
  notificacaoSolicitacaoConcluidaId,
  notificacaoContratoFinanciamentoId,
  contaId
) => {
  try {
    let response = await api.post(
      'PesquisaSatisfacao/RespostaPesquisaSatisfacao',
      {
        imovelId,
        resposta: !question?.ignored ? question.value : null,
        perguntaPesquisaSatisfacaoId: question.Id,
        notificacaoSolicitacaoConcluidaId,
        notificacaoContratoFinanciamentoId,
        comentario: question?.Comentario,
        contaId,
      }
    );

    if (response) return response;
  } catch (error) {
    return false;
  }
};

const postSurveyComment = async (
  imovelId,
  contaId,
  notificacaoSolicitacaoConcluidaId,

  notificacaoContratoFinanciamentoId,
  comentario
) => {
  try {
    let response = await api.post(
      'PesquisaSatisfacao/ComentarioPesquisaSatisfacao',
      {
        imovelId,
        contaId,
        notificacaoSolicitacaoConcluidaId,
        notificacaoContratoFinanciamentoId,
        comentario,
      }
    );

    if (response) return response;
  } catch (error) {
    return false;
  }
};

export {
  getAllNotifications,
  getNotifDestaques,
  getNotifNoticias,
  getNotifVideos,
  getNotifFase,
  getNotifFotos,
  getUrlFotoS3,
  getParcelasPendentes,
  getParcelasVencidas,
  getAgendamentosAbertos,
  getAniversarioNotificacao,
  getVistoriaNaoCompareceu,
  getNotificationHistoric,
  getBoletosVencidos,
  getSurveyQuestions,
  postSurveyQuestions,
  postSurveyComment,
};
